module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-272.cc38292.woff2";